import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { startHeadDedupe } from "@/lib/headDedupe";

startHeadDedupe();

// Production: main.css dimuat tanpa sekat render (critical CSS inline untuk hero). Tunggu ia siap sebelum React mount
// supaya kandungan React tidak muncul tanpa gaya (had 3s sebagai jaring keselamatan).
const cssLink = document.querySelector('link[rel="preload"][as="style"]');
const cssReady = cssLink && cssLink.rel !== 'stylesheet'
  ? new Promise((resolve) => {
      cssLink.addEventListener('load', resolve, { once: true });
      cssLink.addEventListener('error', resolve, { once: true });
      setTimeout(resolve, 3000);
    })
  : Promise.resolve();

const root = ReactDOM.createRoot(document.getElementById("root"));
cssReady.then(() => new Promise((r) => requestAnimationFrame(r))).then(() => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
));
